import React from 'react';
import {
  Dashboard as DashboardIcon,
  Public as CityIcon,
  BusinessCenter as ServiceIcon,
  DirectionsCar as VehicleIcon,
  Settings as SettingsIcon,
  ManageAccounts as AdminIcon,
  Security as SecurityIcon,
  ViewCarousel as ContentIcon,
  Category as CategoryIcon,
  BookOnline,
  People,
  LocalOffer as CouponIcon,
  Tune as ControlIcon,
  Wallet as WalletIcon,
  Share as ReferralIcon,
  History as AuditIcon,
  Group as CustomerIcon,
  Receipt as BookingIcon,
  AccountTree as BranchAccessIcon,
} from '@mui/icons-material';

export interface MenuItem {
  title: string;
  path?: string;
  icon: React.ReactNode;
  /** Role-based visibility: only these roles see this item. Omit = visible to all authenticated. */
  roles?: string[];
  /** Permission-based visibility: any one of these grants visibility (OR logic). Checked when roles don't match. */
  permissions?: string[];
  children?: MenuItem[];
}

export const MENU_ITEMS: MenuItem[] = [
  // ==================== DASHBOARD ====================
  {
    title: 'Dashboard',
    path: '/dashboard',
    icon: <DashboardIcon />,
  },

  // ==================== MASTER DATA (Setup) – Super Admin only ====================
  {
    title: 'Master Data',
    icon: <CategoryIcon />,
    roles: ['SUPER_ADMIN'],
    permissions: ['CITY_READ', 'CATEGORY_READ', 'VEHICLE_READ', 'BANNER_READ', 'COUPON_READ'],
    children: [
      {
        title: 'Cities',
        path: '/cities',
        icon: <CityIcon />,
        permissions: ['CITY_READ'],
      },
      {
        title: 'Our Services',
        path: '/services',
        icon: <ServiceIcon />,
        permissions: ['CATEGORY_READ'],
      },
      {
        title: 'Vehicles',
        path: '/fleet/vehicles',
        icon: <VehicleIcon />,
        permissions: ['VEHICLE_READ'],
      },
      { title: 'Banners', path: '/settings/banners', icon: <ContentIcon />, permissions: ['BANNER_READ'] },
      { title: 'Coupons', path: '/settings/coupons', icon: <CouponIcon />, permissions: ['COUPON_READ'] },
    ],
  },

  // ==================== CONFIGURATION (Rules) – Super Admin only ====================
  {
    title: 'Configuration',
    icon: <SettingsIcon />,
    roles: ['SUPER_ADMIN'],
    permissions: ['SYSTEM_CONFIG_VIEW', 'SUBSCRIPTION_PLAN_VIEW', 'TOPUP_PLAN_VIEW', 'CONTROL_SETTING_READ'],
    children: [
      {
        title: 'Service Setup',
        path: '/service-settings',
        icon: <SettingsIcon />,
        permissions: ['SYSTEM_CONFIG_VIEW'],
      },
      {
        title: 'Recharge Plans',
        path: '/settings/recharge-plans',
        icon: <WalletIcon />,
        permissions: ['SUBSCRIPTION_PLAN_VIEW', 'TOPUP_PLAN_VIEW'],
      },
      {
        title: 'App Controls',
        path: '/settings/app-controls',
        icon: <ControlIcon />,
        permissions: ['CONTROL_SETTING_READ'],
      },
    ],
  },

  // ==================== CUSTOMERS ====================
  {
    title: 'Customers',
    path: '/customer-details/customers',
    icon: <CustomerIcon />,
  },

  // ==================== BOOKINGS ====================
  {
    title: 'Bookings',
    path: '/bookings',
    icon: <BookingIcon />,
  },

  // ==================== OPERATIONS (Day-to-day) ====================
  {
    title: 'Operations',
    icon: <BookOnline />,
    children: [
      {
        title: 'Providers',
        path: '/providers',
        icon: <People />,
      },
    ],
  },

  // ==================== REPORTS (all roles) ====================
  // Temporarily hidden — not yet implemented
  // {
  //   title: 'Reports',
  //   path: '/reports',
  //   icon: <ReportIcon />,
  // },
  // ==================== ADMINISTRATION – Super Admin only ====================
  {
    title: 'Administration',
    icon: <AdminIcon />,
    roles: ['SUPER_ADMIN'],
    permissions: ['ADMIN_VIEW', 'ADMIN_ASSIGN_BRANCH', 'ROLE_VIEW', 'REFERRAL_ANALYTICS_VIEW', 'AUDIT_LOG_READ_SELF'],
    children: [
      {
        title: 'Admin Users',
        path: '/admins',
        icon: <AdminIcon />,
        permissions: ['ADMIN_VIEW'],
      },
      {
        title: 'Branch Access',
        path: '/admin-access',
        icon: <BranchAccessIcon />,
        permissions: ['ADMIN_ASSIGN_BRANCH'],
      },
      {
        title: 'Roles & Access',
        path: '/roles',
        icon: <SecurityIcon />,
        permissions: ['ROLE_VIEW'],
      },
      {
        title: 'Referral',
        path: '/referral',
        icon: <ReferralIcon />,
        permissions: ['REFERRAL_ANALYTICS_VIEW'],
      },
      {
        title: 'Audit Logs',
        path: '/audit-logs',
        icon: <AuditIcon />,
        permissions: ['AUDIT_LOG_READ_SELF'],
      },
    ],
  },
];
